<template>
  <div>
    <div v-if="user.capacity == 'Partner'">
      <div class="row mb-3">
        <div class="col-12">
          <h2 class="m-0">Welcome {{ user.name }}</h2>
          <p
            class="text-muted"
            v-for="partner in partnerPartners"
            :key="partner.id"
          >
            {{ partner.name }}
          </p>
        </div>
      </div>

      <!-- Partner -->

      <div class="row" v-if="user.capacity == 'Partner'">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="card box-shadow h-100">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <h2 class="text-primary font-weight-bold text-monospace">
                        {{ partnerUnreadMessages }}
                      </h2>
                    </div>
                    <div class="col-auto">
                      <i class="lni lni-comments text-muted font-size-26"></i>
                    </div>
                  </div>

                  <p>Unread Messages</p>
                </div>
              </div>
            </div>

            <div class="col-md-6 3 mb-3">
              <div class="card box-shadow h-100">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <h2 class="text-primary font-weight-bold text-monospace">
                        {{ partnerCurrentJobs }}
                      </h2>
                    </div>
                    <div class="col-auto">
                      <i
                        class="lni lni-laptop-phone text-muted font-size-26"
                      ></i>
                    </div>
                  </div>

                  <p>Current Jobs</p>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <div class="card box-shadow h-100">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <h2 class="text-primary font-weight-bold text-monospace">
                        {{ partnerAwaitingQuotationResponse }}
                      </h2>
                    </div>
                    <div class="col-auto">
                      <i class="lni lni-spinner font-size-26 text-muted"></i>
                    </div>
                  </div>

                  <p>Awaiting Quotation Response</p>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <div class="card box-shadow h-100">
                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      <h2 class="text-primary font-weight-bold text-monospace">
                        {{ partnerInbound }}
                      </h2>
                      <p>Inbound - transit</p>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col">
                          <h2
                            class="text-primary font-weight-bold text-monospace"
                          >
                            {{ partnerOutbound }}
                          </h2>
                        </div>
                        <div class="col-auto">
                          <i class="lni lni-ship font-size-26 text-muted"></i>
                        </div>
                      </div>

                      <p>Outbound - transit</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card box-shadow float-right" style="max-width: 400px">
            <div class="card-header bg-white">
              <div class="row">
                <div class="col-12">
                  <img
                    class="img-fluid maxHeight100"
                    v-if="cc && cc.logo"
                    :src="cc.logo"
                  />
                </div>
                <div class="col-12 mt-2">
                  <h5 class="mb-0 font-weight-bold">{{ cc.name }}</h5>
                  <small class="text-black-50">
                    <span v-if="cc.vat_number"
                      >VAT#: {{ cc.vat_number }} |</span
                    >
                    {{ cc.registration_number }}</small
                  >
                </div>
              </div>
            </div>
            <div class="card-body h-100">
              <table class="table table-sm font-size-13">
                <tr>
                  <td class="font-weight-bold w-50 border-0">Tel</td>
                  <td class="border-0">
                    <a :href="'tel:' + cc.contact_number">{{
                      cc.contact_number
                    }}</a>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Email Info</td>
                  <td>
                    <a :href="'mailto:' + cc.email_address_info">{{
                      cc.email_address_info
                    }}</a>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Email Accounts</td>
                  <td>
                    <a :href="'mailto:' + cc.email_address_accounts">{{
                      cc.email_address_accounts
                    }}</a>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Banking</td>
                  <td class="nl2br">{{ cc.banking_details }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold w-50">Address</td>
                  <td class="nl2br">{{ cc.physical_address }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="user.capacity == 'Staff'">
      <div class="col-md-4">
        <vue-custom-scrollbar style="height: 480px">
          <div class="card px-3 py-4 box-shadow">
            <h4 class="font-weight-500 mb-4">Notifcations</h4>

            <span v-for="n in notifications" :key="n.id">
              <div class="row">
                <div class="col-auto">
                  <b-avatar
                    :size="12"
                    :variant="notificationVariant(n.level)"
                    text="."
                  ></b-avatar>
                </div>
                <div class="col">
                  <p class="m-0 p-0">{{ n.message }}</p>
                  <small class="text-muted font-size-11">
                    {{
                      moment(new Date(n.created_at)).format("DD MMM YY, HH:mm")
                    }}
                  </small>
                </div>
                <div class="col-auto">
                  <b-badge
                    v-if="n.job_number"
                    variant="primary"
                    class="float-right no-round text-monospace font-size-13 px-2 py-1"
                    >{{ n.job_number }}</b-badge
                  >
                </div>
              </div>

              <hr />
            </span>
          </div>
        </vue-custom-scrollbar>
      </div>
      <div class="col-md-8">
        <!-- Staff -->
        <div class="row">
          <div class="col-md-6 col-lg-4 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                     
                    >
                      {{ unreadMessages }}
                    </h1>
                  </div>
                  <div class="col-auto text-right font-size-26">
                    <i class="lni lni-comments" :class="{
                        'text-success': unreadMessages == 0,
                        'text-danger': unreadMessages > 0,
                      }"></i>
                  </div>
                </div>

                <p>Unread Messages</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                      
                    >
                      {{ inboundAwaitingWaybill }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-ship font-size-26 " :class="{
                        'text-success': inboundAwaitingWaybill == 0,
                        'text-danger': inboundAwaitingWaybill > 0,
                      }"></i>
                  </div>
                </div>

                <p>Inbound<br> Awaiting Waybill</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                     
                    >
                      {{ outboundAwaitingWaybill }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-ship font-size-26"  :class="{
                        'text-success': outboundAwaitingWaybill == 0,
                        'text-danger': outboundAwaitingWaybill > 0,
                      }"></i>
                  </div>
                </div>

                <p>Outbound<br> Awaiting Waybill</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                      
                    >
                      {{ techAllocation }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-shovel  font-size-26" :class="{
                        'text-success': techAllocation == 0,
                        'text-danger': techAllocation > 0,
                      }"></i>
                  </div>
                </div>

                <p>Tech Allocation</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                     
                    >
                      {{ quotationReview }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-calculator font-size-26"  :class="{
                        'text-success': quotationReview == 0,
                        'text-danger': quotationReview > 0,
                      }"></i>
                  </div>
                </div>

                <p>Quotation Review</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1 class="font-weight-bold text-monospace">
                      {{ currentJobs }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-laptop-phone text-primary font-size-26"></i>
                  </div>
                </div>

                <p>Current Jobs</p>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3">
            <div class="card box-shadow h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <h1 class="font-weight-bold text-monospace">
                      {{ inbound }}
                    </h1>
                    <p>Inbound - transit</p>
                  </div>
                  <div class="col-6">
                    <div class="row">
                      <div class="col">
                        <h1
                          class="font-weight-bold text-monospace"
                        >
                          {{ outbound }}
                        </h1>
                      </div>
                      <div class="col-auto">
                        <i class="lni lni-ship text-primary font-size-26"></i>
                      </div>
                    </div>

                    <p>Outbound - transit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="card box-shadow p-3">
          <horizontal-bar-chart
            v-if="chartReady"
            :chart-data="chartdata"
            :options="options"
          ></horizontal-bar-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerHomeRepo from "@/api/repos/partnerHomeRepo";
import homeRepo from "@/api/repos/homeRepo";
import vueCustomScrollbar from "vue-custom-scrollbar";
import horizontalBarChart from "@/components/charts/horizontalBar";
import colors from "@/data/chart-colors";

export default {
  components: {
    vueCustomScrollbar,
    horizontalBarChart,
  },
  data() {
    return {
      colors: colors,
      timer: null,
      partnerPartners: [], //partners a partner user belongs to
      partnerUnreadMessages: 0,
      partnerAwaitingQuotationResponse: 0,
      partnerInbound: 0,
      partnerOutbound: 0,
      partnerCurrentJobs: 0,
      unreadMessages: 0,
      inboundAwaitingWaybill: 0,
      outboundAwaitingWaybill: 0,
      techAllocation: 0,
      quotationReview: 0,
      inbound: 0,
      outbound: 0,
      currentJobs: 0,
      notifications: [],
      jobStatusLocations: null,
      chartReady:false,
      chartdata: {
        labels: [],
        datasets: [],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
         scales: {
            xAxes: [{
                ticks: {
                    min: 0,
                }
            }]
        }
      },
    };
  },

  mounted() {
    this.getData();
    this.timer = setInterval(this.getData, 60000);
  },

  methods: {
    notificationVariant(level) {
      if (level == 1) {
        return "success";
      } else if (level == 2) {
        return "info";
      } else if (level == 3) {
        return "warning";
      } else {
        return "danger";
      }
    },
    async getData() {

      try{
     
      if (this.user && this.user.capacity == "Partner") {

        let { data } = await partnerHomeRepo.home();
        this.partnerUnreadMessages = data.unread_messages;
        this.partnerPartners = data.partners;
        this.partnerInbound = data.inbound;
        this.partnerOutbound = data.outbound;
        this.partnerCurrentJobs = data.current_jobs;
        this.partnerAwaitingQuotationResponse =
          data.awaiting_quotation_response;
        this.jobStatusLocations = data.job_status_locations

      } else {

        let { data } = await homeRepo.home();
        this.unreadMessages = data.unread_messages;
        this.inboundAwaitingWaybill = data.inbound_awaiting_waybill;
        this.outboundAwaitingWaybill = data.outbound_awaiting_waybill;
        this.techAllocation = data.tech_allocation;
        this.quoationReview = data.quotation_review;
        this.inbound = data.inbound;
        this.outbound = data.outbound;
        this.currentJobs = data.current_jobs;
        this.notifications = data.notifications;
        this.jobStatusLocations = data.job_status_locations
        
      }

      let tempChartData = {
        labels:[],
        datasets:[]
      }
      let d = []
      
      this.jobStatusLocations.forEach((x) => {
        tempChartData.labels.push(
          x.job_status_location.location +
            " - " +
            x.job_status_location.status
        );
        d.push(x.total);
      });
      tempChartData.datasets.push({
        label: "Jobs by status",
        backgroundColor: this.colors,
        data: d,
      });
      this.chartdata = tempChartData
      this.chartReady=true

      }catch(e){
        if (this.timer) clearInterval(this.timer);
      }
      


    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.timer) clearInterval(this.timer);
    next();
  },

  computed: {
    user() {
      return this.$store.state.user.user;
    },
    companies() {
      return this.$store.state.user.companies;
    },
    current_company_id() {
      return this.$store.state.user.current_company_id;
    },
    cc() {
      return this.companies.filter((c) => c.id == this.current_company_id)[0];
    },
  },
};
</script>
